/*!
 * Copyright © 2018-2019. Verizon Connect Ireland Limited. All rights reserved.
 */

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TooltipModule } from 'shared';
import { ContextMenuItemComponent } from './context-menu-item/context-menu-item.component';
import { ContextMenuPanelComponent } from './context-menu-panel/context-menu-panel.component';
import { ContextMenuComponent } from './context-menu.component';

@NgModule({
  imports: [CommonModule, MatIconModule, TooltipModule],
  declarations: [ContextMenuComponent, ContextMenuItemComponent, ContextMenuPanelComponent],
  exports: [ContextMenuComponent, ContextMenuItemComponent, ContextMenuPanelComponent]
})
export class ContextMenuModule {}
